var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcnEventhomePencil(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icn_eventhome_pencil"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M7.25583 16.9222L15 9.17803L11.3217 5.4997L3.5775 13.2439C3.47079 13.3505 3.39504 13.4842 3.35833 13.6305L2.5 17.9997L6.86833 17.1414C7.015 17.1047 7.14917 17.0289 7.25583 16.9222ZM17.5 6.67803C17.8125 6.36548 17.988 5.94164 17.988 5.4997C17.988 5.05776 17.8125 4.63391 17.5 4.32136L16.1783 2.9997C15.8658 2.68724 15.4419 2.51172 15 2.51172C14.5581 2.51172 14.1342 2.68724 13.8217 2.9997L12.5 4.32136L16.1783 7.9997L17.5 6.67803Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcnEventhomePencil);
export default __webpack_public_path__ + "static/media/icn_eventhome_pencil.9f8b0b27af4ad8a410ae2c1a80894c03.svg";
export { ForwardRef as ReactComponent };